export const InvoiceforActionCountAction = {
    AddInvCntForAction: "ADDINVCNTFORACTION",
    RemInvCntForAction: "REMINVCNTFORACTION"
}

const InitInvCntforAction = 0;

export const InvoiceCntForActionReducer = (invCntforAction = InitInvCntforAction, actions) => {
    switch (actions.type) {

        case InvoiceforActionCountAction.AddInvCntForAction:
            invCntforAction = actions.payload;
            return invCntforAction;
        case InvoiceforActionCountAction.RemInvCntForAction:
            invCntforAction = 0;
            return invCntforAction;
        default:
            return invCntforAction;
    }
}